import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { Box, useTheme } from '@mui/material';

interface ScrollbarProps {
  className?: string;
  children?: ReactNode;
}

const Scrollbar: FC<ScrollbarProps> = ({ className, children, ...rest }) => {
  const theme = useTheme();

  return (
    <Scrollbars
      autoHide
      // To remove scroll bar visibility in some views.
      // renderView={({ style, ...props }) => (
      //   <div
      //     {...props}
      //     style={{
      //       ...style,
      //       marginRight: '-16px',
      //       marginBottom: '-16px',
      //       overflowX: 'hidden'
      //     }}
      //   />
      // )}
      renderThumbVertical={() => {
        return (
          <Box
            sx={{
              width: 5,
              background: `${theme.colors.alpha.black[10]}`,
              borderRadius: `${theme.general.borderRadiusLg}`,
              transition: `${theme.transitions.create(['background'])}`,

              '&:hover': {
                background: `${theme.colors.alpha.black[30]}`
              }
            }}
          />
        );
      }}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
};

Scrollbar.propTypes = {
  children: PropTypes.node as unknown as PropTypes.Validator<ReactNode>,
  className: PropTypes.string
};

export default Scrollbar;
